import { api } from './client';
export async function uploadAudio(blob) {
    const formData = new FormData();
    formData.append('file', blob, 'voice.webm');
    const res = await api('/api/audio/upload', {
        method: 'POST',
        body: formData,
    });
    return { audioUrl: res.url };
}
